import { Injectable } from '@angular/core';
import { ApiparserService } from '../apiparser/apiparser.service';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private parser: ApiparserService,
    private SessionService: SessionService
  ) {}

  login(userInfo: object) {
    return this.parser
      .hit('/authenticate', 'post', userInfo, true)
      .then((response) => this.SessionService.auth(response));
  }

  public isLoggedIn() {
    const expiresAt = localStorage.getItem('sportseed:tokenExpireAt');
    if (!expiresAt) return false;
    return new Date(expiresAt) > new Date();
  }

  register(params) {
    return this.parser.hit('/user/register', 'post', { params: params });
  }

  getAllUsers(params) {
    return this.parser.hit('/rest/users', 'get', {params: params}, false, true);
  }
  updateUser(id, name) {
    return this.parser.hit('/rest/users', 'put', {
      id: id,
      name: name,
    });
  }
  deleteUser(id) {
    console.log('delete id' + id);

    return this.parser.hit('/rest/users', 'delete', { params: { id: id } });
  }
}
